// extracted by mini-css-extract-plugin
export default {"container":"container_JrwZN","legalWarning":"legalWarning_Xt8MX"};